export default "__VITE_ASSET__h3XhxNYw__"